import React from 'react';
import styled from '@emotion/styled';

const StyledEditable = styled.div`
  border: 1px solid transparent;
  display: inline-block;
  width: 100%;
  min-height: 20px;

  &:hover {
    border: 1px dotted gray;
  }
`;

export default function Editable({ enabled = true, className, children, ...rest }) {
  if (!enabled) {
    return (
      <div className={className} {...rest}>
        {children}
      </div>
    );
  }
  return (
    <StyledEditable className={className} {...rest}>
      {children}
    </StyledEditable>
  );
}
